import React from 'react';

const LOGO_URL = "https://customer-assets.emergentagent.com/job_eeacbd60-db8b-4da1-8e71-db72803ff0fd/artifacts/f4528czt_Screenshot%202024-07-25%20103325.png";

export const Footer = () => {
  return (
    <footer className="bg-white border-t border-slate-200 mt-auto">
      <div className="container-main py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <img 
              src={LOGO_URL} 
              alt="EYB Logo" 
              className="h-8 w-8 object-contain"
            />
            <span className="font-heading font-semibold text-slate-900">
              EYB Consulting
            </span>
          </div>
          
          <div className="footer-disclaimer">
            EYB Consulting provides business advisory services only and does not provide credit advice. 
            Lending decisions are made solely by the lender.
          </div>
          
          <div className="text-sm text-slate-500">
            © {new Date().getFullYear()} EYB Consulting
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
